import { Optional, Pipe, PipeTransform } from '@angular/core';
import { ColorsService } from './colors.service';

@Pipe({
  name: 'colors'
})
export class ColorsPipe implements PipeTransform {

  constructor( @Optional() public _colorsService: ColorsService) { }

  transform(value: any, ...args: any[]): any {
    return this._colorsService?.getColor(value);
  }

}
